import MomentUtils from "@date-io/moment";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { useStyles } from "components/layout/CommonStyles";
import Footer from "components/layout/Footer";
import Spinner from "components/layout/spinners/Index";
import ProjectsContext from "context/projects/projectsContext";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Redirect } from "react-router-dom";
import { animated, useTransition } from "react-spring";
import DashboardNavBar from "../../layout/DashboardNavBar";
import SideBar from "../../layout/sidebar/Sidebar";
import ViewHeading from "./ViewHeading";
import ViewQuota from "./ViewQuota";

const ViewSubsidy = ({ match }) => {
    const classes = useStyles();
    const [t] = useTranslation();
    const [quotas, setQuotas] = useState([]);
    const [projectId, setProjectId] = useState(0);
    const projectsContext = useContext(ProjectsContext);
    const {
        loading,
        subsidy,
        getSubsidy,
        project,
        getProject,
    } = projectsContext;
    const [quotasCount, setQuotasCount] = useState(0);
    const [mustRedirect, setMustRedirect] = useState(false);
    const [allHeadings, setAllHeadings] = useState([
        { "name": "RH Direto", "value": "", "id": 0 },
        { "name": "RH Indireto", "value": "", "id": 0 },
        { "name": "Equipamentos", "value": "", "id": 0 },
        { "name": "Material de Consumo", "value": "", "id": 0 },
        { "name": "Livros e Periódicos", "value": "", "id": 0 },
        { "name": "Viagens", "value": "", "id": 0 },
        { "name": "Custos Incorridos", "value": "", "id": 0 }
    ]);

    const [totalRubrics, setTotalRubrics] = useState("");

    const transitions = useTransition(loading, null, {
        from: { opacity: 0 },
        enter: {
            opacity: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "calc(100vh - 80px)"
        },
        leave: { opacity: 0 }
    });

    const [state, setState] = useState({
        projectName: "",
        gpf: "",
        seasonId: 0,
        subsidyValue: "",
        subsidyDescription: ""
    });

    const [dates, setDates] = useState({
        subsidyDate: new Date(),
        minDate: new Date(),
        maxDate: new Date()
    });

    useEffect(() => {
        getSubsidy(match.params.id);
        if (subsidy.addendum) {
            getProject(subsidy.addendum.projectId);

            while (quotas.length) {
                quotas.pop();
            }


            if (project.information) {
                setProjectId(project.id);

                let subsidyTotal = subsidy.total
                    .toFixed(2)
                    .split("")
                    .filter(el => el !== "." && el !== ",")
                    .join("");

                let totalValue = converTotBrCurrency(
                    subsidyTotal
                        .split("")
                        .reverse()
                        .join("")
                );

                setState({
                    ...state,
                    projectName: project.information.name,
                    gpf: project.information.gpf,
                    subsidyValue: totalValue,
                    subsidyDescription: subsidy.description
                });

                let cooperationTerm = project.sgppdAddendum.filter(el => el.number !== "GENERAL" &&
                    el.cooperationTerm === true)[0];

                let lastTerm = project.sgppdAddendum.filter(el => el.number !== "GENERAL")[
                    project.sgppdAddendum.length - 2];

                //let cooperationTermStart = new Date(cooperationTerm.startdate);
                let cooperationTermStart = new Date(cooperationTerm.startdate);
                cooperationTermStart.setMinutes(cooperationTermStart.getMinutes() + cooperationTermStart.getTimezoneOffset())

                var subsidyDateFormated = new Date(subsidy.subsidyDate)
                subsidyDateFormated.setMinutes(subsidyDateFormated.getMinutes() + subsidyDateFormated.getTimezoneOffset())

                setDates({
                    ...dates,
                    subsidyDate: subsidyDateFormated,
                    minDate: cooperationTermStart,
                    maxDate: lastTerm.enddate
                });

                let headings = [];
                let auxHead = {};

                for (let j in subsidy.projectSubsidyHeading) {
                    let sabedHeading = subsidy.projectSubsidyHeading[j].headingValue
                        .toFixed(2)
                        .split("")
                        .filter(el => el !== "." && el !== ",")
                        .join("");

                    let valueHead = converTotBrCurrency(
                        sabedHeading
                            .split("")
                            .reverse()
                            .join("")
                    );

                    auxHead.name = subsidy.projectSubsidyHeading[j].headingName;
                    auxHead.value = valueHead;
                    auxHead.id = subsidy.projectSubsidyHeading[j].id;
                    headings.push(auxHead);
                    auxHead = {};
                }

                setAllHeadings(headings);

                for (let i in subsidy.projectSubsidyQuota) {

                    let value = subsidy.projectSubsidyQuota[i].quotaValue
                        .toFixed(2)
                        .split("")
                        .filter(el => el !== "." && el !== ",")
                        .join("");

                    let quotavalue = converTotBrCurrency(
                        value
                            .split("")
                            .reverse()
                            .join("")
                    );
                    
                    //let savedQuotaDate = new Date(subsidy.projectSubsidyQuota[i].quotaMonth);
                    let savedQuotaDate = new Date(subsidy.projectSubsidyQuota[i].quotaMonth);
                    savedQuotaDate.setMinutes(savedQuotaDate.getMinutes() + savedQuotaDate.getTimezoneOffset())
                    let newDate = new Date(savedQuotaDate.getFullYear(), savedQuotaDate.getMonth());

                    addQuota(
                        subsidy.projectSubsidyQuota[i].quotaNumber,
                        quotavalue,
                        newDate,
                        subsidy.projectSubsidyQuota[i].id
                    );
                }
            }
        }
    }, [JSON.stringify(project), JSON.stringify(subsidy)]);

    const converTotBrCurrency = number => {
        var temp = "";
        var len = number.length;
        var count = 0;

        for (var i = 0; i < len; i++) {
            if (i === 1) {
                var aux = "," + number[i] + temp;
                temp = aux;
            } else {
                if (count === 3) {
                    count = 1;
                    var aux = number[i] + "." + temp;
                    temp = aux;
                } else {
                    if (i > 1) {
                        count += 1;
                    }
                    var aux = number[i] + temp;
                    temp = aux;
                }
            }
        }

        return temp;
    };

    const addQuota = (
        quotaNumber,
        quotavalue,
        quotaDate,
        quotaId
    ) => {
        quotas.push(
            <div
                id={"divQuota" + (quotas.length)}
                key={quotas.length}
                className="subsidyQuotas"
                data-quota-id={quotaId}
            >
                <ViewQuota
                    opacity={1}
                    lastQuota={quotas.length}
                    quotaNumber={quotaNumber}
                    quotavalue={quotavalue}
                    quotaDate={quotaDate}
                />
            </div>
        );

        setQuotasCount(quotasCount + 1);
    };

    const backToProject = () => {
        setMustRedirect(true);
    };

    const redirect = go => {
        if (go) return <Redirect to={`/execution/projects/${projectId}/edit`} />;
    };

    function formattedMoney(value) {
        var valuerFormatted = value ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : 0
        if (valuerFormatted !== "NaN") {
            return valuerFormatted;
        } else {
            return "0";
        }
    }

    const updateFields = () => {
        var len = document.getElementsByClassName("subsidyHeadings").length;
        var total = 0;

        for (var i = 0; i < len; i++) {
            var stageClass = document.getElementsByClassName("subsidyHeadings")[i]
            var value = stageClass.getElementsByTagName("input")[0]
                ? stageClass.getElementsByTagName("input")[0].value
                : null

            if (value) {
                var currencyStr = value
                    .split("")
                    .filter(el => el !== ".")
                    .join("")
                    .replace(",", ".");
                total += parseFloat(currencyStr);
            }
        }

        var totalResult = formattedMoney(total);
        setTotalRubrics(totalResult)
    };

    return transitions.map(({ item, key, props }) =>
        item ? (
            <animated.div key={key} style={props}>
                <Spinner />
            </animated.div>
        ) : (
                <animated.div key={key} style={props}>
                    {redirect(mustRedirect)}
                    <DashboardNavBar />
                    <SideBar />
                    <div className="container">
                        <Breadcrumbs
                            className={classes.breadCrumbs}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon fontSize="small" />}
                        >
                            <Typography>{t("PARTICIPANTS.labor")}</Typography>
                            <Link className={classes.link} to="/execution/projects/">
                                {t("PROJECTS.projects")}
                            </Link>
                            <Link
                                className={classes.link}
                                to={`/execution/projects/${projectId}/edit`}
                            >
                                {t("PROJECTS.project")}
                            </Link>
                            <Typography>{t("SUBSIDY.viewSubsidy")}</Typography>
                        </Breadcrumbs>
                        <div className="container-header">
                            <div className="title">
                                <h1 className={classes.title}>{t("SUBSIDY.viewSubsidy")}</h1>
                                <Typography>
                                    <span className={classes.projectInformation}>GPF: </span>
                                    <span className={classes.projectInformation2}>{`${state.gpf}`}</span>
                                    <span className={classes.projectInformation}> | PROJETO: </span>
                                    <span className={classes.projectInformation2}>{`${state.projectName}`}</span>
                                </Typography>
                            </div>
                            <Button
                                className={classes.blueButton}
                                variant="contained"
                                color="primary"
                                onClick={backToProject}
                            >
                                {t("GENERAL.back").toUpperCase()}
                            </Button>
                        </div>
                        <Paper className={classes.root}>
                            <div className={classes.header}>
                                {t("SUBSIDY.subsidyInformation").toUpperCase()}
                            </div>
                            <div className={classes.bodyForm}>
                                <Grid container>
                                    <Grid container item spacing={2} md={12} lg={12}>
                                        <Grid item xs={6}>
                                            <TextField
                                                disabled
                                                id="subsidyValue"
                                                label={t("SUBSIDY.subsidyTotalValue")}
                                                className={classes.textField}
                                                margin="normal"
                                                name="subsidyValue"
                                                value={state.subsidyValue}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">R$</InputAdornment>
                                                    )
                                                }}
                                            />
                                        </Grid>
                                        <MuiPickersUtilsProvider locale="pt" utils={MomentUtils}>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    disabled
                                                    fullWidth
                                                    label={t("SUBSIDY.subsidyDate")}
                                                    id="subsidyDate"
                                                    variant="inline"
                                                    openTo="year"
                                                    name="yearBase"
                                                    views={["year", "month"]}
                                                    format="DD/MM/YYYY"
                                                    margin="normal"
                                                    autoOk={true}
                                                    value={dates.subsidyDate}
                                                />
                                            </Grid>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={classes.bodyForm}>
                                <Grid container>
                                    <Grid container item spacing={2} md={12} lg={12}>
                                        <Grid item xs={12}>
                                            <TextField
                                                disabled
                                                id="subsidyDescription"
                                                multiline
                                                fullWidth
                                                variant="outlined"
                                                rows="6"
                                                label={t("PROFILES.descriptionLabel")}
                                                margin="normal"
                                                value={state.subsidyDescription}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </Paper>
                        <Paper className={classes.root} style={{ marginTop: "22px" }}>
                            <div className={classes.header}>
                                {t("SUBSIDY.subsidyQuotas").toUpperCase()}
                            </div>
                            <div className={classes.bodyForm}>
                                <Grid container spacing={2}>
                                    <Grid item xs={4} style={{ fontWeight: "bold", opacity: "0.54" }}>
                                        {t("SUBSIDY.quotaNumber").toUpperCase()}
                                    </Grid>
                                    <Grid item xs={4} style={{ fontWeight: "bold", opacity: "0.54" }}>
                                        {t("BUDGET.balanceValue").toUpperCase()}
                                    </Grid>
                                    <Grid item xs={3} style={{ fontWeight: "bold", opacity: "0.54" }}>
                                        {t("SUBSIDY.quotaMonth").toUpperCase()}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={1}
                                        style={{ marginTop: "-12px", marginBottom: "-15px" }}
                                    >
                                    </Grid>
                                    <div className="lineBreak"></div>
                                </Grid>
                            </div>
                            <div>{quotas}</div>
                        </Paper>
                        <Paper className={classes.root} style={{ marginTop: "22px" }}>
                            <div className={classes.header}>
                                {t("PROFILES.form.headings").toUpperCase()}
                            </div>
                            <div className={classes.bodyForm}>
                                <Grid container spacing={2}>
                                    <Grid item xs={4} style={{ fontWeight: "bold", opacity: "0.54" }}>
                                        {t("EXPENSES.rubricLabel").toUpperCase()}
                                    </Grid>
                                    <Grid item xs={4} style={{ fontWeight: "bold", opacity: "0.54" }}>
                                        {t("GENERAL.value").toUpperCase()}
                                    </Grid>
                                    <div className="lineBreak"></div>
                                </Grid>
                            </div>
                            <div>
                                {
                                    allHeadings.map(function (heading, index) {
                                        return (
                                            <div
                                                key={index}
                                                id={"divHeading" + index}
                                                className="subsidyHeadings"
                                                data-heading-id={heading.id}
                                            >
                                                <ViewHeading
                                                    index={index}
                                                    headingName={heading.name}
                                                    headingValue={heading.value}
                                                    updateFields={updateFields}
                                                />
                                            </div>
                                        )
                                    })
                                }
                                <div className={classes.bodyForm}>
                                    <Grid container spacing={2}>
                                        <Grid id={"Total"} item xs={4}>
                                            Total
                                    </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                id={"tatalValue"}
                                                className={classes.textField}
                                                margin="normal"
                                                name="headingTotalValue"
                                                value={totalRubrics}
                                                disabled
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">R$</InputAdornment>
                                                    )
                                                }}
                                            />
                                        </Grid>
                                        <div className="lineBreak"></div>
                                    </Grid>
                                </div>
                            </div>
                        </Paper>
                    </div>
                    <Footer />
                </animated.div>
            )
    );
};

export default ViewSubsidy;